import { useCallback } from 'react';
import { useRxData } from 'rxdb-hooks';

import { RxdbCollectionName } from '../rxdbCollectionName';
import { ComponentRemovalCategories, ComponentRemovalCategoriesCollection } from './queryBuilder';

const useComponentRemovalCategories = () => {
  const getComponentRemovalCategoriesQuery = useCallback(
    (collection: ComponentRemovalCategoriesCollection) =>
      collection?.find({ selector: { isActive: true } }),
    [],
  );

  const { result: componentRemovalCategories } = useRxData<ComponentRemovalCategories>(
    RxdbCollectionName.COMPONENT_REMOVAL_CATEGORIES,
    getComponentRemovalCategoriesQuery,
    { json: true },
  );

  return { componentRemovalCategories };
};

export default useComponentRemovalCategories;
